/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {SwwcTree} from '@com.siemens.plm.horizon/swwc/bindings/react';

interface InformationProps {
  item: Record<string, unknown> | null;
  map: Record<
    string,
    {
      id: string;
      name: string;
    }
  >;
}

export class Information extends React.Component<InformationProps> {
  override render() {
    return <div className='content'>{this.#processItem(this.props.item)}</div>;
  }

  #processItem(item: unknown): React.ReactNode {
    if (item === undefined || item === null) return undefined;
    if (Array.isArray(item)) {
      return (
        // @ts-ignore
        <SwwcTree closed='false'>
          <ol>
            {item.map((ele, index) =>
              ele !== null && typeof ele === 'object' ? (
                <li key={index}>
                  <label></label>
                  {this.#processItem(ele)}
                </li>
              ) : (
                <li key={index}>{this.#processItem(ele)}</li>
              ),
            )}
          </ol>
        </SwwcTree>
      );
    }
    if (typeof item === 'object') {
      return (
        // @ts-ignore
        <SwwcTree closed='false'>
          <ul>
            {Object.entries(item)
              .map((entry) => {
                const key = this.props.map[entry[0]];
                if (key === undefined) return {id: entry[0], name: entry[0], item: entry[1]};
                return {id: key.id, name: key.name, item: entry[1]};
              })
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((entry) => (
                <li key={entry.id}>
                  <label>{entry.name}: </label>
                  {this.#processItem(entry.item)}
                </li>
              ))}
          </ul>
        </SwwcTree>
      );
    }
    let render;
    switch (typeof item) {
      case 'boolean':
        render = item ? 'true' : 'false';
        break;
      case 'string':
        render = item;
        break;
      case 'number':
      case 'bigint':
        render = item.toString();
        break;
      case 'undefined':
        return undefined;
      case 'symbol':
        render = item.description;
        break;
      case 'function':
        render = item.toString();
        break;
      default:
        render = String(item);
        break;
    }
    return (
      <ul>
        <li>{render}</li>
      </ul>
    );
  }
}
